var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { themes } from '@shapeable/theme';
import deepmerge from 'deepmerge';
export var ThemeProviderDefaultProps = {
  theme: 'DEFAULT_THEME',
  overrides: {}
};
// -------- Components -------->
export var ThemeProvider = function (props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
  var children = props.children,
    overrides = props.overrides;
  // deprecation patches to slowly migrate to better token names
  var patchedOverrides = __assign({}, overrides);
  if (((_b = (_a = overrides === null || overrides === void 0 ? void 0 : overrides.light) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b.bright) && !((_d = (_c = overrides === null || overrides === void 0 ? void 0 : overrides.light) === null || _c === void 0 ? void 0 : _c.color) === null || _d === void 0 ? void 0 : _d.canvas)) {
    patchedOverrides.light.color.canvas = overrides.light.color.bright;
  }
  if (((_f = (_e = overrides === null || overrides === void 0 ? void 0 : overrides.dark) === null || _e === void 0 ? void 0 : _e.color) === null || _f === void 0 ? void 0 : _f.bright) && !((_h = (_g = overrides === null || overrides === void 0 ? void 0 : overrides.dark) === null || _g === void 0 ? void 0 : _g.color) === null || _h === void 0 ? void 0 : _h.canvas)) {
    patchedOverrides.dark.color.canvas = overrides.dark.color.bright;
  }
  if (((_k = (_j = overrides === null || overrides === void 0 ? void 0 : overrides.light) === null || _j === void 0 ? void 0 : _j.color) === null || _k === void 0 ? void 0 : _k.brightWarm) && !((_m = (_l = overrides === null || overrides === void 0 ? void 0 : overrides.light) === null || _l === void 0 ? void 0 : _l.color) === null || _m === void 0 ? void 0 : _m.appChrome)) {
    patchedOverrides.light.color.appChrome = overrides.light.color.brightWarm;
  }
  if (((_p = (_o = overrides === null || overrides === void 0 ? void 0 : overrides.dark) === null || _o === void 0 ? void 0 : _o.color) === null || _p === void 0 ? void 0 : _p.brightWarm) && !((_r = (_q = overrides === null || overrides === void 0 ? void 0 : overrides.dark) === null || _q === void 0 ? void 0 : _q.color) === null || _r === void 0 ? void 0 : _r.appChrome)) {
    patchedOverrides.dark.color.appChrome = overrides.dark.color.brightWarm;
  }
  var themeObj = themes[props.theme] || themes.WEB_THEME;
  var finalThemeObj = deepmerge(themeObj, patchedOverrides);
  return React.createElement(StyledComponentsThemeProvider, {
    theme: finalThemeObj
  }, children);
};
ThemeProvider.defaultProps = ThemeProviderDefaultProps;